export default __webpack_public_path__ + "static/media/socialTele.05e44463.png";